import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-check',
  templateUrl: './icon-check.component.html',
  styleUrls: ['./icon-check.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCheckComponent {}
